// ── 3D icon sources (thiings.co) ──

export const ICONS = {
  // Main nav rows
  personalInfo: require("../../../assets/images/you-icons/personal-info.png"),
  medicalFertility: require("../../../assets/images/you-icons/medical-fertility.png"),
  coverageBenefits: require("../../../assets/images/you-icons/coverage-benefits.png"),
  connections: require("../../../assets/images/you-icons/connections.png"),
  research: require("../../../assets/images/you-icons/research.png"),
  notifications: require("../../../assets/images/you-icons/notifications.png"),
  integrations: require("../../../assets/images/you-icons/integrations.png"),
  account: require("../../../assets/images/you-icons/account.png"),
  preferences: require("../../../assets/images/you-icons/calendar.png"),
  security: require("../../../assets/images/you-icons/shield.png"),

  // Detail section icons
  envelope: require("../../../assets/images/you-icons/envelope.png"),
  phone: require("../../../assets/images/you-icons/phone.png"),
  calendar: require("../../../assets/images/you-icons/calendar.png"),
  user: require("../../../assets/images/you-icons/user.png"),
  heart: require("../../../assets/images/you-icons/heart.png"),
  mapPin: require("../../../assets/images/you-icons/map-pin.png"),
  blood: require("../../../assets/images/you-icons/blood.png"),
  alert: require("../../../assets/images/you-icons/alert.png"),
  building: require("../../../assets/images/you-icons/building.png"),
  hashtag: require("../../../assets/images/you-icons/hashtag.png"),
  sparkle: require("../../../assets/images/you-icons/sparkle.png"),
  shield: require("../../../assets/images/you-icons/shield.png"),
  beaker: require("../../../assets/images/you-icons/beaker.png"),
  anonymousDataContribution: require("../../../assets/images/you-icons/anonymous-data-contribution.png"),
  padlock: require("../../../assets/images/you-icons/padlock.png"),
  moon: require("../../../assets/images/you-icons/moon.png"),
  tablet: require("../../../assets/images/you-icons/tablet.png"),
  syringe: require("../../../assets/images/you-icons/syringe.png"),
  trash: require("../../../assets/images/you-icons/trash.png"),
  arrowDown: require("../../../assets/images/you-icons/arrow-down.png"),
  door: require("../../../assets/images/you-icons/door.png"),
  notificationMedication: require("../../../assets/images/you-icons/notification-medication-row-3d.png"),
  notificationAppointment: require("../../../assets/images/you-icons/notification-appointment-row-3d.png"),
  notificationCycle: require("../../../assets/images/you-icons/notification-cycle-row-3d.png"),
  notificationTestResults: require("../../../assets/images/you-icons/notification-test-results-row-3d.png"),
  notificationDocuments: require("../../../assets/images/you-icons/notification-documents-row-3d.png"),
  notificationCoverage: require("../../../assets/images/you-icons/notification-coverage-row-3d.png"),
};

// These are the dedicated icon family for You overview rows and detail-dialog
// headers. Keeping the same sources in both places prevents a section from
// switching visual languages when it opens.
export const ROW_ICONS = {
  personalInfo: require("../../../assets/images/you-icons/personal-info-row-3d.png"),
  medicalFertility: require("../../../assets/images/you-icons/medical-fertility-row-3d.png"),
  coverageBenefits: require("../../../assets/images/you-icons/coverage-benefits-row-3d.png"),
  connections: require("../../../assets/images/you-icons/connections-row-3d.png"),
  research: require("../../../assets/images/you-icons/research-row-3d.png"),
  notifications: require("../../../assets/images/you-icons/notifications-row-3d.png"),
  integrations: require("../../../assets/images/you-icons/integrations-row-3d.png"),
  preferences: require("../../../assets/images/you-icons/preferences-row-3d.png"),
  account: require("../../../assets/images/you-icons/account-row-3d.png"),
};

// Re-export shared tint filter
export { TINTED_ICON_FILTER } from "../../../shared/icons";
